define('views/modules/calendar/animated-session/exercise/cardio/cardio-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/menu/menu',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/exercise/cardio/cardio-content.html',
    'text!templates/modules/calendar/animated-session/exercise/exercise-menu-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Views
    VMenu,
    // Template
    TWeightExerciseContent,
    TExerciseMenuItem
) {

    var VCardioExerciseContent = Backbone.Epoxy.View.extend({
        template: TWeightExerciseContent,

        regions: {
            menu: ".menu-actions",
            graph: ".exercise-cardio-graph",
        },

        initialize: function(opt) {

            this.collection = this.model.getPhases();

            // Actions menu
            this.actionCollection = new Backbone.Collection([
                { title: 'note:Notes', callback: this.onToggleNoteAction, toggle: true, icon: 'sl-icon-note', },
                { title: 'Edit cardio exercise data', callback: this.onEditAction, icon: 'sl-icon-pencil', },
                { title: 'calendar:Convert this exercise to cardio', callback: this.onConvertToWeightAction, toggle: true, active: true, icon: 'fa fa-bar-chart', },
                { title: 'calendar:Duplicate exercise weeks to other exercises', callback: this.onDuplicateWeeksAction, icon: 'fa fa-clone', },
            ]);

            this.view = {
                menu: new VMenu({
                    context: this,
                    radio: false,
                    collection: this.actionCollection,
                    templateItem: TExerciseMenuItem,
                }),
            };

            this.listenTo(this.collection, "update", this.onUpdate);

            this.listenTo(this.model, {
                "change:loadEnabled": this.onLoadToggle
            });


        },

        render: function() {

            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);

            this.generateZones();

            this.assign(this.view.menu, this.zone.$menu);


            this.resetList();

            return this;
        },


        resetList: function() {
            // render the table header
            // this.zone.$list.html(Mustache.render(TWeightExerciseTableHeader, Mustache.getContext()));
            // this.removeChildViews();
            // _.defer(this.addAll.bind(this));
        },


        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onToggleNoteAction: function(model) {
            this.trigger('toggle:note');
        },

        onEditAction: function() {

        },

        onConvertToWeightAction: function() {

        },

        onDuplicateWeeksAction: function() {

        },

        ////////////
        // events //
        ////////////

        onUpdate: function(collection, options) {
            // if (options.changes.added) {
            //     _.defer(this.addAll.bind(this), options.changes.added);
            // }
        }


    });

    return VCardioExerciseContent;

});

